(function () {
  'use strict';
  if (window.MomentaLaunchSignup) {
    window.MomentaLaunchSignup.mount(document);
    return;
  }

  var mounted = new WeakSet();
  var draftMessage = 'Preview only. Email signup isn’t connected yet.';

  function mount(root) {
    var forms = Array.from(root.querySelectorAll('[data-momenta-signup]'));
    if (root.matches && root.matches('[data-momenta-signup]')) forms.unshift(root);
    forms.forEach(function (form) {
      if (mounted.has(form)) return;
      mounted.add(form);
      var emailInput = form.querySelector('input[name="email"]');
      var button = form.querySelector('button[type="submit"]');
      var status = form.querySelector('[data-momenta-signup-status]');
      var consent = form.querySelector('input[data-momenta-consent]');
      var busy = false;
      var accepted = false;
      var buttonLabel = form.dataset.buttonLabel || (button ? button.textContent : 'Notify me');
      var listId = form.dataset.listId;
      var optIn = form.dataset.optIn;
      var configured = form.dataset.enabled === 'true'
        && form.dataset.companyId === 'TSs9LN'
        && /^[A-Za-z0-9]{6}$/.test(listId || '')
        && ['single_opt_in', 'double_opt_in'].includes(optIn);

      function announce(message, state) {
        if (!status) return;
        status.textContent = message;
        status.dataset.state = state;
      }

      if (status) {
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
      }
      if (button) {
        button.disabled = !configured;
        if (configured) button.textContent = buttonLabel;
      }
      if (emailInput) emailInput.disabled = !configured;
      if (!configured) announce(form.dataset.previewMessage || draftMessage, 'preview');
      else announce('', 'ready');

      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (!configured || !emailInput || !button || !status) {
          announce(form.dataset.previewMessage || draftMessage, 'preview');
          return;
        }
        if (busy || accepted) return;
        if (!form.checkValidity() || (consent && !consent.checked)) {
          form.reportValidity();
          if (consent && !consent.checked) announce(form.dataset.consentMessage || 'Please agree to receive Momenta launch news before joining.', 'error');
          return;
        }
        var email = emailInput.value.trim();
        if (!email || email.length > 254) {
          announce(form.dataset.invalidEmailMessage || 'Please enter a valid email address.', 'error');
          return;
        }
        busy = true;
        button.disabled = true;
        button.textContent = form.dataset.busyMessage || 'Sending…';
        emailInput.readOnly = true;
        form.setAttribute('aria-busy', 'true');
        announce(form.dataset.pendingMessage || 'Sending your request…', 'pending');
        var controller = new AbortController();
        var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
        try {
          var response = await window.fetch('https://a.klaviyo.com/client/subscriptions?company_id=TSs9LN', {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            redirect: 'error',
            cache: 'no-store',
            headers: {
              accept: 'application/vnd.api+json',
              'content-type': 'application/vnd.api+json',
              revision: '2026-07-15'
            },
            signal: controller.signal,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Momenta coming-soon signup',
                  profile: {data: {type: 'profile', attributes: {
                    email: email,
                    subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
                  }}}
                },
                relationships: {list: {data: {type: 'list', id: listId}}}
              }
            })
          });
          if (response.status === 202 && response.type !== 'opaque') {
            accepted = true;
            emailInput.value = '';
            announce(optIn === 'double_opt_in'
              ? (form.dataset.successMessage || 'Thanks! Check your inbox to confirm your interest in Momenta.')
              : (form.dataset.singleSuccessMessage || 'Thanks! Your Momenta signup request has been received.'), 'accepted');
          } else if (response.status === 429) {
            announce(form.dataset.rateLimitMessage || 'We’re receiving lots of requests. Please wait a moment, then try again.', 'error');
          } else if (response.status === 400 || response.status === 422) {
            announce(form.dataset.invalidEmailMessage || 'Please check your email address and try again.', 'error');
          } else {
            announce(form.dataset.errorMessage || 'We couldn’t confirm your signup. Please try again in a moment.', 'error');
          }
        } catch (error) {
          announce(form.dataset.errorMessage || 'We couldn’t confirm your signup. Please check your connection and try again.', 'error');
        } finally {
          window.clearTimeout(timeout);
          busy = false;
          emailInput.readOnly = accepted;
          button.disabled = accepted;
          button.textContent = accepted ? (form.dataset.acceptedLabel || 'Request received') : buttonLabel;
          form.setAttribute('aria-busy', 'false');
        }
      });
    });
  }

  window.MomentaLaunchSignup = {mount: mount};
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); }, {once: true});
  } else mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
}());
